<template>
  <button :type="type" :class="classNames" :data-qa="dataQa" :disabled="disabled || null">
    <slot />
  </button>
</template>

<script>
// The design system's button. Deliberately not built on AppButton: that
// component's scoped reset (padding, margin-bottom, white text, icon margins)
// would have to be fought on every rule here, and every change to it would
// touch the ~40 pages still on the legacy design.
//
// `@click` (and any other listener or attribute) falls through to the native
// <button> element, so there is nothing to re-emit.
//
// It carries no <style> of its own — the styling lives in styles/ds/_button.scss
// and only applies inside a page that opted in with `ds-root`.

const VARIANTS = ['primary', 'ghost', 'danger', 'text']
const SIZES = ['md', 'sm']

export default {
  name: 'DsButton',
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => VARIANTS.includes(value),
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => SIZES.includes(value),
    },
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    dataQa: {
      type: String,
      required: true,
    },
  },
  computed: {
    classNames() {
      return [
        'ds-button',
        `ds-button--${this.variant}`,
        this.size !== 'md' && `ds-button--${this.size}`,
        this.block && 'ds-button--block',
      ].filter(Boolean)
    },
  },
}
</script>
